import React, { useCallback } from 'react';
import { useForm } from 'react-final-form';

import AddMoreButton from '../../AddMoreButton/AddMoreButton';

type Props = {
  onClick: Function;
};

export default function AddMoreTopicsButton({ onClick }: Props) {
  const {
    mutators: { push },
  } = useForm();

  const handleClick = useCallback(() => {
    push('discussionTopics', { editable: true, checked: true, label: null });
    setTimeout(onClick);
  }, [onClick, push]);

  return <AddMoreButton action={handleClick} />;
}
